<ng-template #confirmDialogTemplate>
    <form class="se-auth-dialog-container se-flex se-expand" (ngSubmit)="closeModal(false)">
        <div class="se-flex se-vertical se-expand">
            <div class="se-dialog-header mat-elevation-z6" [class.se-dialog-header-error]="isOnError">
                <h3 mat-dialog-title translate>Authenticate</h3>
            </div>

            <div class="se-sign-dialog-content" mat-dialog-content [class.se-sign-dialog-waiting]="isWaiting | async">
                <div class="mat-input-container">
                    <mat-form-field appearance="outline">
                        <mat-label>{{ "Username" | translate }}</mat-label>
                        <input
                            name="confirm_username"
                            matInput
                            [placeholder]="'Username' | translate"
                            [(ngModel)]="data.userName"
                            tabindex="-1"
                            readonly
                        />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>{{ "Password" | translate }}</mat-label>
                        <input
                            #pwd
                            name="confirm_pwd"
                            [type]="showPassword ? 'text' : 'password'"
                            matInput
                            [placeholder]="'Password' | translate"
                            [(ngModel)]="data.password"
                            autocomplete="new-password"
                            required
                        />
                        <button
                            type="button"
                            matSuffix
                            mat-icon-button
                            aria-label="Show"
                            (click)="showPassword = !showPassword"
                            tabindex="-1"
                        >
                            <mat-icon>{{ showPassword ? "visibility_off" : "visibility" }}</mat-icon>
                        </button>
                        <button
                            *ngIf="!!data.password"
                            type="button"
                            matSuffix
                            mat-icon-button
                            aria-label="Clear"
                            (click)="data.password = ''"
                            tabindex="-1"
                        >
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
                <p style="flex-grow: 1; font-size: 0.9em; margin: 0 10px">{{ errorMessage }}</p>
            </div>
            <div class="se-sign-dialog-action-container" mat-dialog-actions>
                <button
                    mat-button
                    color="primary"
                    class="se-dialog-action-button"
                    type="button"
                    (click)="closeModal(true)"
                    translate
                >
                    <span translate>Cancel</span>
                </button>

                <button
                    mat-button
                    class="se-dialog-action-button"
                    type="button"
                    color="primary"
                    [disabled]="!enableAuthenticateButton()"
                    (click)="closeModal(false)"
                >
                    <span translate>Confirm</span>
                </button>

                <button type="submit" [disabled]="!enableAuthenticateButton()" style="display: none">
                    hidden submit
                </button>
            </div>
        </div>
    </form>

    <div class="estensa-spinner" style="background-color: transparent !important" *ngIf="isWaiting | async">
        <mat-spinner diameter="64" color="accent"></mat-spinner>
    </div>
</ng-template>
